import React, { useState, ChangeEvent, useEffect } from "react";
import { Box, TextField, FormControl, styled, Paper } from "@mui/material";
import { IDateRange } from "../../interfaces/campaign";
import dayjs from "dayjs";
import { useAppDispatch } from "../../redux/store";
import { fetchReportThunk } from "../../redux/thunks/report.thunk";
import { IWithClassName } from "../../theme/default.theme";

interface IProps extends IWithClassName {
    dateHandler: (dateRange: IDateRange) => void;
}

const DateRange = ({ className, dateHandler }: IProps) => {
    const dispatch = useAppDispatch();

    const [dateRange, setDateRange] = useState<IDateRange>({
        startDate: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
        endDate: dayjs().format("YYYY-MM-DD"),
    });

    const dateChangeHandler = (label: string) => ({target}: ChangeEvent<HTMLInputElement>) => {
        setDateRange((range) => (
            {
            ...range,
            [label]: target.value,
            }
        ))
    };

    useEffect(() => {
        dispatch(fetchReportThunk({startDate: dateRange.startDate ?? dayjs().subtract(1, "day").format("YYYY-MM-DD"),
            endDate: dateRange.endDate ?? dayjs().format("YYYY-MM-DD"),
            includeImpression: true,
            kpiFields: "",
            groupBy: "created",
            page: 1,
            column: "",
            order: "asc",}));

        dateHandler(dateRange);
    }, [dispatch, dateRange, dateHandler]);

    return (
        <Box className={className} component={Paper}>
            <FormControl className="metrics-date">
                <TextField
                    type="date"
                    value={dateRange.startDate}
                    onChange={dateChangeHandler("startDate")}
                />
                <TextField
                    type="date"
                    value={dateRange.endDate}
                    onChange={dateChangeHandler("endDate")}
                />
            </FormControl>
        </Box>
    );
};

export default styled(DateRange)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(1.5),

    ".metrics-date": {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: 10,
        width: 300,
        marginLeft: "auto",
    },
}));